<template>
  <b-modal ref="SalesInvoiceCommissionFeeModal"
           :no-close-on-backdrop="true" :no-enforce-focus="true" size="md">
    <div slot="modal-title">
      <div class="d-flex">
        <h5 class="modal-title">
          {{title}}
        </h5>
      </div>
    </div>
    <div>
      <b-row>
        <b-col>
          {{$t('labels.agents.invoice_sum')}} ({{base_currency.code}}): {{commissionFee.sale_invoice_total_base_curr}}
        </b-col>
        <b-col>
          {{$t('labels.agents.transport_fee')}} ({{base_currency.code}}): {{commissionFee.sale_invoice_transport}}
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          {{$t('labels.invoice.sold')}}: {{commissionFee.sold}}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex align-items-center">
          <b-col class="pl-0">
            <label class="important-field m-0" title="This field is required to save commission fee">
              {{$t('labels.common.agent')}}
            </label>
          </b-col>
          <b-col class="pr-0">
            <multiselect v-model="commissionFee.agent" :max-height="200"
                         label="name" track-by="name" :class="{ required: !commissionFee.agent}"
                         :options="agents" :multiple="false" :close-on-select="true" :disabled="isRelatedWithAgentInvoice && !isNewCommissionFee"
                         select-label="" deselect-label="" selected-label="" placeholder=""
                         @select="fetchCommissions"/>
          </b-col>
        </b-col>
        <b-col class="d-flex align-items-center">
          <b-col class="pl-0">
            <label class="m-0">{{$t('labels.agents.commissions')}}</label>
          </b-col>
          <b-col class="pr-0">
            <multiselect v-model="commissionFee.commission" :max-height="200"
                         label="description" track-by="description" :options="commissions" :multiple="false"
                         select-label="" deselect-label="" selected-label="" placeholder=""
                         :disabled="!commissionFee.agent"
                         :close-on-select="true" @select="setCommissionFeeData"/>
          </b-col>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex align-items-center">
          <b-col class="pl-0">
            <label class="important-field m-0" title="This field is required to save commission fee">
              {{$t('labels.agents.commission_type')}}
            </label>
          </b-col>
          <b-col class="pr-0">
            <multiselect v-model="commissionFee.commission_type" :max-height="200"
                         label="name" track-by="name" :class="{ required: !commissionFee.commission_type}"
                         select-label="" deselect-label="" selected-label="" placeholder=""
                         :disabled="isRelatedWithAgentInvoice && !isNewCommissionFee"
                         :options="commissionTypes" :multiple="false" :close-on-select="true"/>
          </b-col>
        </b-col>
        <b-col class="d-flex align-items-center">
          <b-col class="pl-0">
            <label class="important-field m-0" title="This field is required to save commission fee">
              {{$t('labels.agents.commission_currency')}}
            </label>
          </b-col>
          <b-col class="pr-0">
            <multiselect v-model="commissionFee.currency" :max-height="200"
                         label="code" track-by="code" :class="{ required: !commissionFee.currency}"
                         select-label="" deselect-label="" selected-label="" placeholder=""
                         :disabled="isRelatedWithAgentInvoice && !isNewCommissionFee"
                         :options="currencies" :multiple="false" :close-on-select="true"/>
          </b-col>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex align-items-center">
          <b-col class="pl-0">
            <label class="important-field m-0" title="This field is required to save commission fee">
              {{$t('labels.agents.commission_uom')}}
            </label>
          </b-col>
          <b-col class="pr-0">
            <multiselect v-model="commissionFee.measure_type" :max-height="200"
                         :class="{ required: !commissionFee.measure_type}"
                         select-label="" deselect-label="" selected-label="" placeholder=""
                         :disabled="isRelatedWithAgentInvoice && !isNewCommissionFee"
                         :options="measure_types" :multiple="false" :close-on-select="true"/>
          </b-col>
        </b-col>
        <b-col class="d-flex align-items-center">
          <b-col class="pl-0">
            <label class="important-field m-0" title="This field is required to save commission fee">
              {{$t('labels.agents.commission_value')}}
            </label>
          </b-col>
          <b-col class="pr-0">
            <input
              v-model="commissionFee.value"
              class="form-control"
              :class="{ required: !commissionFee.value}"
              :disabled="isRelatedWithAgentInvoice && !isNewCommissionFee"/>
          </b-col>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex align-items-center">
          <b-col class="pl-0">
            <label class="m-0">{{$t('labels.agents.commission_sum')}}</label>
          </b-col>
          <b-col class="pr-0">
            <input v-model="commissionFee.sum" class="form-control" disabled/>
          </b-col>
        </b-col>
        <b-col class="d-flex align-items-center">
          <b-col class="pl-0">
            <label class="m-0">{{$t('labels.common.notes')}}</label>
          </b-col>
          <b-col class="pr-0">
            <b-textarea v-model="commissionFee.notes" class="form-control"/>
          </b-col>
        </b-col>
      </b-row>
    </div>
    <div slot="modal-footer" class="w-100 d-flex justify-content-center align-items-center">
      <b-btn size="sm" class="ml-2" variant="success" @click="save"
             title="Save" :disabled="isDataEmpty">
        {{$t('buttons.common.save')}}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';

  import { handlerResponse, setNotifyData } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';

  export default {
    props: ['parentInvoiceId', 'fetchCommissionFeesCb', 'customerId'],
    components: {
      Multiselect
    },
    data() {
      return {
        commissionFeeInitial: {
          agent: null,
          commission_type: null,
          currency: null,
          id: null,
          invoice: null,
          measure_type: '',
          notes: '',
          sale_invoice_total_base_curr: null,
          sale_invoice_transport: null,
          sold: '',
          sum: null,
          sum_base_curr: null,
          value: null,
          commission: null
        },
        commissionFee: {},
        commissions: []
      }
    },
    computed: {
      ...mapState('generic', ['currencies', 'commissionTypes']),
      ...mapState('partners', ['agents']),
      ...mapState('woodware', ['measure_types', 'base_currency']),
      isRelatedWithAgentInvoice() {
        return !!this.commissionFee.sale_agent_invoice_number;
      },
      title() {
        return this.isNewCommissionFee ? this.$t('modal_dialogs.sales_agent_commission_fee.commission_fee')
          : `${this.$t('modal_dialogs.sales_agent_commission_fee.commission_fee')} ${this.commissionFee.invoice.invoice_number}`
      },
      isNewCommissionFee() {
        return !this.commissionFee.id;
      },
      isDataEmpty() {
        return !this.commissionFee.agent || !this.commissionFee.commission_type || !this.commissionFee.measure_type
          || !this.commissionFee.value || !this.commissionFee.currency
      }
    },
    methods: {
      prepareSaveData() {
        const data = {
          agent: this.commissionFee.agent ? this.commissionFee.agent.id : '',
          currency: this.commissionFee.currency ? this.commissionFee.currency.id : '',
          commission_type: this.commissionFee.commission_type ? this.commissionFee.commission_type.key : '',
          value: this.commissionFee.value,
          notes: this.commissionFee.notes,
          measure_type: this.commissionFee.measure_type
        };
        if (this.isNewCommissionFee) {
          data.invoice = this.parentInvoiceId;
        } else {
          data.invoice = this.commissionFee.invoice ? this.commissionFee.invoice.id : '';
        }
        return data;
      },
      async setSaleAgentCommissionFeeData(response) {
        const {sold, sale_invoice_total_base_curr, sale_invoice_transport, sum} = response;
        this.commissionFee.sold = sold;
        this.commissionFee.sale_invoice_total_base_curr = sale_invoice_total_base_curr;
        this.commissionFee.sale_invoice_transport = sale_invoice_transport;
        this.commissionFee.sum = sum;
        await this.fetchCommissionFeesCb();
        this.$refs['SalesInvoiceCommissionFeeModal'].hide();
      },
      save() {
        const saveData = this.prepareSaveData();
        if (this.isNewCommissionFee) {
          this.$http.post('accounting/sale_agent_commission_fees/', saveData)
            .then(handlerResponse)
            .then(async response => {
              await this.setSaleAgentCommissionFeeData(response);
            }).catch((error) => {
            notificationsRenderer(error.body, 'error');
          });
        } else {
          this.$http.put(`accounting/sale_agent_commission_fees/${this.commissionFee.id}/`, saveData)
            .then(handlerResponse)
            .then(async response => {
              await this.setSaleAgentCommissionFeeData(response);
              this.$notify(setNotifyData('Success', 'Commission fee has been updated!', 'success'));
            }).catch((error) => {
            notificationsRenderer(error.body, 'error');
          })
        }
      },
      async fetchCommissions(selectAgent) {
        const agentId = selectAgent.id;
        this.commissionFee.commission = null;
        try {
          const params = {
            agent_id: agentId,
            customer_id: this.customerId
          };
          this.commissions = await this.$http.get(`accounting/sale_agent_commissions_list/`, {params}).then(handlerResponse);
        } catch (error) {
          notificationsRenderer(error.body, 'error');
        }
      },
      async setCommissionFeeData(selectCommission) {
        const id = selectCommission.id;
        try {
          const data = await this.$http.get(`accounting/sale_agent_commissions/${id}/`).then(handlerResponse);
          this.commissionFee.measure_type = data.measure_type;
          this.commissionFee.value = data.value;
          this.commissionFee.commission_type = data.type;
          this.commissionFee.currency = data.currency;
        } catch (error) {
          notificationsRenderer(error.body, 'error');
        }
      },
      loadSettings() {
        this.$store.dispatch('partners/getSaleAgents');
        this.$store.dispatch('generic/getCurrencies');
        this.$store.dispatch('generic/loadCommissionTypes');
      }
    },
    mounted() {
      this.$root.$on('openSalesInvoiceCommissionFeeModal', (commissionFee) => {
        if (commissionFee) {
          this.commissionFee = {...this.commissionFeeInitial, ...commissionFee};
        } else {
          this.commissionFee = {...this.commissionFeeInitial};
        }
        if (this.$refs['SalesInvoiceCommissionFeeModal']) {
          this.loadSettings();
          this.$refs['SalesInvoiceCommissionFeeModal'].show();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openSalesInvoiceCommissionFeeModal');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/SalesInvoiceCommissionFeeModal.vue